import { HttpService } from '../http.service'
import { v4 as uuidv4 } from 'uuid'
const bucketUpload = import.meta.env.VITE_BUCKET_UPLOAD

const http = new HttpService()

export async function saveFile(
  contentFile: any,
  nameFile: string,
  folder: string = 'Reports',
  bucket: string = bucketUpload || 'sbx-aps-temporary-bucket',
  type: string = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
): Promise<any> {
  const data: any = {
    folder,
    bucket,
    file: {
      name: '',
      data: '',
      type,
      encoding: 'base64'
    }
  }
  data.file.name = `${uuidv4()}${nameFile}`
  data.file.data = contentFile.toString('base64')
  try {
    const result: any = await http.post('upload/s3', data)

    return result.data.url
  } catch (error: any) {
    return false
  }
}

export async function downloadFile(
  nameFile: string,
  bucket?: string
): Promise<any> {
  const data: any = {
    bucket: bucket !== '' ? bucket : bucketUpload || 'sbx-aps-temporary-bucket',
    name: nameFile
  }

  try {
    const result: any = await http.post('upload/get-s3', data)
    return result.data.ok ? result.data.data.url : result.data
  } catch (error: any) {
    return false
  }
}
